/** «Простои» — ровно то, что отдаёт `GET /api/activity/idle`. */
import { apiFetch, query } from "@/lib/api";

export type IdleGap = { from: string; to: string; minutes: number; missed: number };

export type IdleDay = {
  date: string;
  paid_min: number;
  accept_min: number;
  accepted: boolean;
  idle_min: number | null;
  idle_pct: number | null;
  idle: IdleGap[];
};

export type IdlePerson = {
  user_id: number;
  name: string;
  paid_min: number;
  accept_min: number;
  unaccepted_min: number;
  pending_days: number;
  idle_min: number | null;
  idle_pct: number | null;
  idle_count: number | null;
  idle_missed: number | null;
  days: IdleDay[];
};

export type IdleReport = {
  from: string;
  to: string;
  location: { id: number; name: string };
  locations: { id: number; name: string }[];
  activity: boolean;
  idle_min_threshold: number;
  people: IdlePerson[];
  totals: Omit<IdlePerson, "user_id" | "name" | "days"> & { people: number };
};

export function loadIdle(p: { from: string; to: string; location: number; user?: number }): Promise<IdleReport> {
  return apiFetch<IdleReport>(`/api/activity/idle${query(p)}`);
}

export const KC = 3;

const iso = (d: Date) => d.toLocaleDateString("sv-SE");

/** Понедельник недели дня `d`; полдень — чтобы переход на летнее время не съел день. */
function monday(d: Date): Date {
  const m = new Date(d);
  m.setHours(12, 0, 0, 0);
  m.setDate(m.getDate() - ((m.getDay() + 6) % 7));
  return m;
}

/** Прошлая неделя — по умолчанию; эта — с понедельника по сегодня. */
export function lastWeek(): { from: string; to: string } {
  const a = monday(new Date());
  a.setDate(a.getDate() - 7);
  const b = new Date(a);
  b.setDate(b.getDate() + 6);
  return { from: iso(a), to: iso(b) };
}

export function thisWeek(): { from: string; to: string } {
  return { from: iso(monday(new Date())), to: iso(new Date()) };
}

/** Цвет % простоя: < 15 зелёный, < 30 жёлтый, иначе красный (спека). */
export function pctClass(pct: number | null): string {
  if (pct === null) return "text-fg-faint";
  if (pct < 15) return "text-ok";
  if (pct < 30) return "text-warn";
  return "text-err";
}
